import { INITIAL_WEBSITE_TYPE, WebsiteTypeFilter } from "pro-features/components/filtersPanel/src/WebsiteTypeFilter";
import type { FC } from "react";
import type { IFilters } from "app/pages/industry-analysis/market-builder/tabs/industry/table/types";
import { TrafficFilterDropdown } from "app/pages/industry-analysis/market-builder/tabs/industry/table/table-top/TrafficFilterDropdown";
import { BaseFlex } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";
import { allTrackers } from "app/services/track/track";

interface ITableTop {
    filters: IFilters;
    setFilters: (filters: IFilters) => void;
}

const Container = styled(BaseFlex)`
    padding: 12px 16px;
    gap: 8px;
`;

export const TableTop: FC<ITableTop> = (props) => {
    const { filters, setFilters } = props;
    const { traffic, websiteType } = filters;
    const setFiltersHof = (filter: keyof IFilters) => (value) => {
        setFilters({ ...filters, [filter]: value });
    };

    const onWebsiteTypeFilterItemClick = (websiteType) => {
        setFiltersHof("websiteType")(websiteType);

        allTrackers.trackEvent("Filter Table", "click", `By industry/Website Type/${websiteType.text}`);
    };

    const onCloseWebsiteTypeItem = () => {
        setFiltersHof("websiteType")(INITIAL_WEBSITE_TYPE);

        allTrackers.trackEvent("Filter Table", "click", `By industry/Website Type/Clear filter`);
    };

    return (
        <Container>
            <TrafficFilterDropdown
                setTraffic={setFiltersHof("traffic")}
                traffic={traffic}
            />
            <WebsiteTypeFilter
                websiteType={websiteType.text}
                onCloseWebsiteTypeItem={onCloseWebsiteTypeItem}
                onWebsiteTypeItemClick={onWebsiteTypeFilterItemClick}
            />
        </Container>
    );
};
